import type { ProductPreOrderSettings } from '@spa/generated/graphql/graphql';

// Mirrors the preorder-active check already duplicated across product UI components (tracking-only).
export const isPreOrderActive = (
  preOrderSettings: ProductPreOrderSettings | null,
  preOrderEnabled: boolean
): boolean => preOrderEnabled && preOrderSettings?.isActive === true;
